export const GET_TABLE_DATA = "GET_TABLE_DATA";


// WEBPACK FOOTER //
// ./src/types/tableActionTypes.js